import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {Gallery, IframeItem, ImageItem} from '@ngx-gallery/core';
import {Image, Images} from 'src/modules/catalogue/models/image.model';
import {Lightbox} from '@ngx-gallery/lightbox';

@Component({
    selector: 'app-image-gallery',
    templateUrl: './image-gallery.component.html',
    styleUrls: ['./image-gallery.component.scss']
})
export class ImageGalleryComponent implements OnChanges {

    @Input() public images: Images;
    @Input() public name: string;
    @Input() public label: string;

    public readonly galleryId = 'gallery';

    constructor(public gallery: Gallery, public lightbox: Lightbox) {
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.images && this.images) {
            this.loadGalleryItems();
        }
    }

    private loadGalleryItems(): void {
        const galleryRef = this.gallery.ref(this.galleryId);
        galleryRef.setConfig({
            loadingMode: 'indeterminate',
            zoomOut: 7,
            counter: false
        });
        galleryRef.load(this.images.map((image) => this.buildGalleryItem(image)));
    }

    private buildGalleryItem(image: Image) {
        if (image.youtubeId) {
            return new IframeItem({
                src: 'https://www.youtube.com/embed/' + image.youtubeId + '?rel=0&modestbranding=1&autoplay=1',
                thumb: image.thumb
            });
        }

        return new ImageItem({
            src: image.src,
            thumb: image.thumb,
            title: image.caption
        });
    }
}
